import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const actionListReportsPdfFn = ({
  locationIds,
  period,
  include_unverified_savings,
}: {
  locationIds: Array<number>;
  period?: string;
  include_unverified_savings: boolean;
}) =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/report/cost-savings/export`, {
    params: {
      location_ids: locationIds,
      period,
      include_unverified_savings: +include_unverified_savings,
    },
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/octet-stream',
    },
  });

export const useActionListReportsPdfMutation = () => {
  return useMutation({
    mutationFn: actionListReportsPdfFn,
  });
};
